module.exports = __webpack_public_path__ + "static/media/pressure-injury-1.891c9a17.mp3";